import { userResolution } from './filters'
import { adjustScopeConversationAssigneeToActionUser } from './scopes'

export const averageResolutionTimeWithinBusinessHours = {
  adjustScope: adjustScopeConversationAssigneeToActionUser,
  analysisType: 'average',
  eventCollection: 'conversation.resolved',
  filters: [userResolution],
  key: 'averageResolutionTimeWithinBusinessHours',
  targetProperty: 'time.conversation_open_for_within_business_hours',
}
